const $slider_node_type5 = $(".js-slider-type5");

if($slider_node_type5.length){

    setTimeout(function(){

        $slider_node_type5.owlCarousel({
            loop:false,
            margin:10,
            dots:true,
            items: 1,
            smartSpeed: 500,
            responsive: {
                0: {
                    mouseDrag: true,
                    touchDrag: true,
                },
                768: {
                    mouseDrag: false,
                    touchDrag: false,
                },
            },
        })
    },0);
}
